module.exports = __webpack_public_path__ + "img/amir.da27286a.jpg";